import CheckmarkFill from "~icons/eva/checkmark-fill"
import styles from "./styles.module.scss"
import classNames from "classnames"
import { observer } from "mobx-react-lite"

export const ModalCheckbox = observer(
  ({
    onPress,
    testID,
    label,
    isChecked,
    disabled,
    checkboxClassName,
    textClassName,
  }: {
    onPress?: () => void
    testID?: string
    label?: string
    isChecked?: boolean
    disabled?: boolean
    checkboxClassName?: string
    textClassName?: string
  }) => {
    return (
      <button
        type="button"
        data-testid={testID}
        className={classNames(styles.pressable, disabled ? styles.disabled : "", checkboxClassName)}
        onClick={() => {
          if (onPress) onPress()
        }}
        disabled={disabled}
      >
        {isChecked ? (
          <div className={styles.checkedBox}>
            <CheckmarkFill />
          </div>
        ) : (
          <div className={styles.uncheckedBox}>
            <CheckmarkFill className={styles.icon} />
          </div>
        )}
        <span
          className={classNames(styles.label, disabled ? styles.disabledText : "", textClassName)}
        >
          {label}
        </span>
      </button>
    )
  },
)
